import React from 'react';

import { CtaIcon } from './autotest/AutotestFocusedNav';
import ChurnedUserReactivationButton from './ChurnedUserReactivationButton';
import PremiumText from './PremiumText';
import PremiumButton from './PremiumButton';
import { CtaEmphasis } from './autotest/AutotestFocusedNav';
import { PremiumUpsells } from './types';

type Props = {
  premiumUpsells?: PremiumUpsells;
  isMobileNav: boolean;
  /** Autotest CTA label override (AutotestFocusedNav `ctaLabel` surface). */
  ctaLabel?: string | null;
  /** Autotest CTA icon override (AutotestFocusedNav `ctaIcon` surface). */
  ctaIcon?: CtaIcon;
  /** Autotest CTA emphasis override (AutotestFocusedNav `ctaEmphasis` surface). */
  ctaEmphasis?: CtaEmphasis;
  /**
   * Reactivation autotest copy override (AutotestFocusedNavReactivation
   * `reactivateLabel` surface) for the churned "Reactivate Premium" CTA. null
   * (control) keeps today's offer-derived text.
   */
  reactivateLabel?: string | null;
};

const PremiumUpsellButton = ({
  premiumUpsells,
  isMobileNav,
  ctaLabel,
  ctaIcon = 'lock',
  ctaEmphasis,
  reactivateLabel,
}: Props) => {
  if (premiumUpsells?.churnedUserReactivationDiscount) {
    return (
      <ChurnedUserReactivationButton
        discount={premiumUpsells?.churnedUserReactivationDiscount}
        isMobileNav={isMobileNav}
        reactivateLabel={reactivateLabel}
      />
    );
  }

  if (isMobileNav) {
    // NB: ctaEmphasis ('gold') is intentionally NOT passed to the mobile CTA.
    // PremiumText renders a DS TextButtonLink (transparent text button) styled by
    // text_button.scss, which doesn't consume the --button-primary-fill var the
    // gold treatment sets, so there'd be no gold fill — only an inert font-weight
    // bump. The v_cta_gold arm is therefore a desktop treatment (and the trial-CTA
    // CTR metric is desktop-only — mobile PremiumText has no ImpressionWatcher).
    return (
      <PremiumText
        coupon={premiumUpsells?.halfOffCoupon}
        reactivate={premiumUpsells?.reactivatePremiumUpsellType}
        newUserDiscount={premiumUpsells?.newUserDiscount}
        trialPricingCopy={premiumUpsells?.trialPricingCopy}
        ctaLabel={ctaLabel}
        ctaIcon={ctaIcon}
      />
    );
  } else {
    return (
      <PremiumButton
        coupon={premiumUpsells?.halfOffCoupon}
        reactivate={premiumUpsells?.reactivatePremiumUpsellType}
        newUserDiscount={premiumUpsells?.newUserDiscount}
        trialPricingCopy={premiumUpsells?.trialPricingCopy}
        ctaLabel={ctaLabel}
        ctaIcon={ctaIcon}
        ctaEmphasis={ctaEmphasis}
      />
    );
  }
};

export default PremiumUpsellButton;
